import { DropDownStyleType } from 'components/PrintViewer/types';

export type DropdownType = {
  isOpen?: boolean;
  isLoading?: boolean;
  inputId: string;
  dataTestId?: string;
  label: React.ReactNode;
  size?: InputSize;
  onChange: (selectedValue: DropdownValue) => void;
  options: DropdownValue[];
  value: DropdownValue | undefined;
  isRequired?: boolean;
  isDisabled?: boolean;
  errorMessage?: React.ReactNode;
  hasError?: boolean;
  enableCustomValidation?: boolean;
  styles?: DropDownStyleType;
  menuListStyles?: DropDownStyleType;
  placeHolder?: string | React.ReactNode;
  zIndexPrinter?: number;
};

export enum InputSize {
  LARGE = 'large',
  SMALL = 'small',
  STANDARD = 'standard'
}

export type DropdownValue = {
  label: string;
  value: string;
  'data-testid'?: string;
  postingDescriptionRequired?: boolean;
};

export type DropdownOption = {
  label: string;
  value: string;
};
